<footer>
  <div class="rightSection justify-content-center d-md-flex p-3 align-items-center flex-fill">
    <div class="container">
      <div class="row">

        <div class="col-sm-9">
          <p class="copyright">Copyright © 2024. All rights reserved to<span> Maharashtra Small Scale Industries Development Corporation Ltd</span></p>
        </div>
        <div class="col-sm-3 mt-mob">
          <p class="maintain">Designed by <a href="https://mahait.org/" target="_blank">MAHAIT</a></p>
        </div>




      </div>
    </div>
  </div>
</footer>
